import React from 'react';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface LegalLayoutProps {
  children: React.ReactNode;
}

export function LegalLayout({ children }: LegalLayoutProps) {
  return (
    <div className="min-h-screen bg-deep-night text-pearl-white">
      {/* Header with Back to Naia button */}
      <div className="bg-deep-night border-b border-white/10 p-4">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-naia-pink hover:bg-naia-pink/80 text-pearl-white transition-colors"
        >
          <ArrowBackIcon fontSize="small" />
          <span className="font-medium">Back to Naia</span>
        </Link>
      </div>
      
      {/* Main content */}
      <main className="max-w-4xl mx-auto px-6 py-8">
        {children}
      </main>
    </div>
  );
} 